/**
 * represents various print types
 */
export enum PrintHtmlType {
  Invoice = 'I',
  Default = 'D',
  WorkOrder = 'W',
}
